import React from 'react';
import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';

export type { TextProps };

const ProTypographyText: React.FC<TextProps> = (props) => {
  const { children, ...resProps } = props;

  return <Typography.Text {...resProps}>{children}</Typography.Text>;
};

export default ProTypographyText;
